import { Navigate, Outlet, useLocation } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const RedirectIfUserAlreadyLogged = () => {
    const auth = useAuth();
    const location = useLocation();

    return auth.user ? (
        <Navigate to='/' state={{ from: location }} replace />
    ) : (
        <Outlet />
    );
};
export default RedirectIfUserAlreadyLogged;
